/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* MANDATORY lens actions, needed to save, edit and add to cart */

export default {
  genericAddToCart: function (_frameObject, _lensObject, _warrantyObject) {
    alert('Calling genericAddToCart()')
  },

  genericSaveEditFromCart: function (_frameObject, _lensObject, _warrantyObject, _cartMode) {
    alert('Calling genericSaveEditFromCart()')
  },

  genericSaveLensSelection: function (_frameObject, _lensObject, _warrantyObject) {
    alert('Calling genericSaveLensSelection()')
  },

  getPrices: function (_frameObject) {
    alert('Calling getPrices()')
  },

  loadLearnMoreContent: function (_loadMoreContentName) {
    // see Learn more section content retrieval
  },

  loadContent: function (contentName) {
    return Promise.resolve()
    /* const { storeId } = wcs.getStoreConfig()
    var url = `${window.location.origin}/wcs/resources/store/${storeId}/espot/${contentName}`
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var response = new Response(xhr.response, { status: 200 })

        response.json().then(function(data) {
          if (
            data.MarketingSpotData &&
            data.MarketingSpotData.length > 0 &&
            data.MarketingSpotData[0].baseMarketingSpotActivityData &&
            data.MarketingSpotData[0].baseMarketingSpotActivityData.length > 0 &&
            data.MarketingSpotData[0].baseMarketingSpotActivityData[0]
              .marketingContentDescription &&
            data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription
              .length > 0 &&
            data.MarketingSpotData[0].baseMarketingSpotActivityData[0]
              .marketingContentDescription[0].marketingText
          ) {
            let codeHtml =
              data.MarketingSpotData[0].baseMarketingSpotActivityData[0]
                .marketingContentDescription[0].marketingText

            resolve(codeHtml)
          }
        })
      }
      xhr.onerror = function() {
        //reject(new Error('Local request failed'));
        console.warn('Local request failed')
      }

      xhr.open('GET', url)
      xhr.responseType = 'arraybuffer'
      xhr.send(null)
    }) */
  },

  genericExit: function () {
    // optional function to trigger events on configurator closure
  },
}
